
import { useCustomer } from "@/context/CustomerContext";
import { LoadingPage } from "@/components/placeholder/LoadingPage";
import HeaderSection from "@/components/report/HeaderSection";
import EnergyAssessmentSection from "@/components/report/EnergyAssessmentSection";
import SavingsBreakdownSection from "@/components/report/SavingsBreakdownSection";
import PricingRecommendations from "@/components/report/PricingRecommendations";
import WaterAndHeatingRecommendations from "@/components/report/WaterAndHeatingRecommendations";

const Report = () => {
  const { profile, isLoading: profileLoading } = useCustomer();

  if (profileLoading) {
    return <LoadingPage 
      title="Loading Your Report"
      description="Please wait while we fetch your energy report data."
    />;
  }

  if (profile?.status === 'no_input') {
    return (
      <LoadingPage
        title="No Energy Data Available"
        description="Please submit your energy data first to get your personalized report."
        actionLabel="Submit Energy Data"
        actionLink="/submission"
      />
    );
  }

  if (profile?.status === 'input_unprocessed') {
    return (
      <LoadingPage
        title="Processing Your Data"
        description="We are currently processing your energy data. Your report will be available soon."
      />
    );
  }

  return (
    <div className="w-full">
      <HeaderSection />
      <EnergyAssessmentSection />
      <SavingsBreakdownSection />
      <PricingRecommendations />
      <WaterAndHeatingRecommendations />
    </div>
  );
};

export default Report;
